import Article from "./Article";

const Articles= function (props) {
    return (
            <div className="articlesWrap">
                {props.items.map((item,index) => (
                <Article data={item} key={"article_"+index}/>
             )) }
        </div>
    )
}
export default Articles;